import { z } from 'zod';
import { nonEmptyString } from './common.js';
/**
 * Layers and modules are the project's own way of classifying a test case:
 * the layer says what the case exercises (UI, API), the module says which part
 * of the product it belongs to. Both are picked from a catalogue the project
 * administers, never typed on the case, so the same module is not written
 * three ways — exactly what environments do for stands.
 */
/** What a new project starts with; ordinary rows that can be renamed or removed. */
export const DEFAULT_LAYERS = ['API', 'UI'];
/** Modules are the product's own vocabulary, so a project starts with none. */
export const caseAttributeNameSchema = nonEmptyString(60, 'Name');
export const createCaseAttributeSchema = z.object({
    name: caseAttributeNameSchema,
});
export const updateCaseAttributeSchema = z
    .object({
    name: caseAttributeNameSchema.optional(),
})
    .refine((value) => Object.keys(value).length > 0, { message: 'Nothing to update' });
//# sourceMappingURL=case-attribute.js.map